// src/components/Layout/Layout.js
import React from 'react';
import { Box } from '@mui/material';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

function Layout({ children }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: { xs: '80px', md: '100px' }, // Adjust based on header height
          minHeight: '100vh',
        }}
      >
        {children}
      </Box>
      <Footer />
    </Box>
  );
}

export default Layout;